.meta {
  margin-top: var(--s1);
  color: var(--ink2);
}

.readouts {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: var(--s2);
  margin-top: var(--s5);
}

.progressHead {
  display: flex;
  justify-content: space-between;
  margin-top: var(--s5);
}

.done {
  color: var(--ink2);
}

.bar {
  height: 8px;
  margin-top: var(--s2);
  border-radius: 4px;
  background: var(--panel2);
  border: 1px solid var(--line);
  overflow: hidden;
}

.fill {
  display: block;
  height: 100%;
  background: var(--slate);
}

@media (prefers-reduced-motion: no-preference) {
  .fill {
    transition: width 250ms ease-out;
  }
}

.rows {
  margin-top: var(--s5);
}

/* Project home and Projects (DESIGN_SYSTEM §4). Rows, never cards. */
.sheetBody {
  padding: var(--s2) 0 var(--s4);
}

.sheetActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
  margin-top: var(--s3);
}

.field {
  display: block;
  margin-top: var(--s3);
}

.input {
  width: 100%;
  min-height: var(--target);
  margin-top: var(--s1);
  padding: 0 var(--s3);
  border: 1px solid var(--line);
  border-radius: var(--r-control);
  background: var(--pad);
  color: var(--ink);
  font: inherit;
}

.notes {
  width: 100%;
  min-height: 40vh;
  padding: var(--s3);
  border: 1px solid var(--line);
  border-radius: var(--r-control);
  background: var(--pad);
  color: var(--ink);
  font: inherit;
  line-height: 1.5;
  resize: vertical;
}

.chipWrap {
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
  margin-top: var(--s3);
}

.filters {
  display: flex;
  gap: var(--s2);
  margin-top: var(--s4);
}

.bottom {
  position: sticky;
  bottom: 0;
  margin-top: auto;
  padding: var(--s4) 0;
  background: var(--panel);
}

.sectionTitle {
  margin: var(--s5) 0 var(--s2);
}

.why {
  max-width: 68ch;
}

.todo {
  margin: 0;
  padding-left: var(--s5);
  max-width: 68ch;
}

.todo li + li {
  margin-top: var(--s1);
}

.defs {
  margin: 0;
}

.defs > div {
  padding: var(--s2) 0;
  border-top: 1px solid var(--line);
}

.defs > div:last-child {
  border-bottom: 1px solid var(--line);
}

.defs dt {
  color: var(--ink2);
}

.defs dd {
  margin: var(--s1) 0 0;
  max-width: 68ch;
}

.doneBar {
  position: sticky;
  bottom: 0;
  display: flex;
  flex-wrap: wrap;
  gap: var(--s2);
  align-items: center;
  padding: var(--s3) 0;
  margin-top: var(--s5);
  background: var(--panel);
}

.check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: var(--target);
  height: var(--target);
  background: var(--pad);
  border: 1px solid var(--line);
  border-radius: var(--r-pad);
  color: var(--ink);
}

.check[aria-pressed='true'] {
  background: var(--ink);
  border-color: var(--ink);
  color: var(--panel);
}

/* The check-out sheet (SPEC F10, DESIGN_SYSTEM §5): rows and pad-style buttons, no cards. */
.summary {
  margin: 0;
  color: var(--ink2);
}

.outcomes {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--s2);
  margin-top: var(--s4);
}

.outcomes > button {
  min-height: 56px;
}

.energy {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--s2);
  margin-top: var(--s4);
}

.finished {
  margin: var(--s1) 0 0;
  color: var(--ink2);
}

.problem {
  margin-top: var(--s4);
  padding: var(--s3) var(--s4);
  background: var(--panel2);
  border-radius: var(--r-readout);
  color: var(--bad);
}

.problem p + p {
  margin-top: var(--s1);
}

.bottomRow {
  display: flex;
  gap: var(--s3);
}

.bottomRow > * {
  flex: 1;
}

.titleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--s3);
}
